module.exports = __webpack_public_path__ + "img/5.38595f2e.jpg";